<app-preloader></app-preloader>
<app-demo-sidebar></app-demo-sidebar>
<router-outlet></router-outlet>